module.exports = __webpack_public_path__ + "static/media/bmt_phungngao.9eb2b566.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bmt_phungngao.jpg
 ** module id = 671
 ** module chunks = 0
 **/